import { render } from "./Teams.vue?vue&type=template&id=0be8f8c9&scoped=true"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"

import "./Teams.vue?vue&type=style&index=0&id=0be8f8c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be8f8c9"]])

export default __exports__